import { useSelector } from "react-redux";

export const useUnreadSupportCount = () => {
  const notifications =
    useSelector((state) => state?.notificationsList)?.notifyInfo || [];
  const sharedLogin = useSelector((state) => state?.sharedLogin);
  const { sharedUserInfo } = sharedLogin || {};
  const tokenInfoList = useSelector((state) => state.tokenInfoList);
  let companyId;
  let userId;

  if (tokenInfoList?.info?.type === "admin") {
    companyId = tokenInfoList?.info?.company?._id;
    userId = tokenInfoList?.info?._id;
  } else if (sharedUserInfo?.empCompanies?.length > 0) {
    companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    userId = tokenInfoList?.info?._id;
  }

  if (!Array.isArray(notifications) || !userId) return 0;

  let count = 0;

  for (let i = 0; i < notifications.length; i++) {
    const notification = notifications[i];

    if (notification?.type !== "support_message") continue;

    const receivers = notification?.receiveTo || [];

    for (let j = 0; j < receivers.length; j++) {
      if (
        receivers[j]?.userId === userId &&
        receivers[j]?.markAsRead === false
      ) {
        count++;
        break;
      }
    }
  }
  return count;
};
